module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "prayer"
    }
  }, [_c('v-app', {
    attrs: {
      "id": "inspire"
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xl12": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)",
      "font-weight": "bold"
    }
  }, [_vm._v("Online Donations")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n              Easy way to send your donations to AMBPPC Trust using UPI, Netbanking and Cards.\n              ")])])], 1)], 1)], 1), _vm._v(" "), [_c('v-list', {
    staticStyle: {
      "background": "rgb(255, 255, 255, 0.5)"
    },
    attrs: {
      "one-line": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": "",
      "href": _vm.razorpayDonationsUrl,
      "target": "_blank"
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": "/static/doc-images/lists/hand-credit-card.png"
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('u', [_vm._v("AMBPPCT Online Donations")])]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticStyle: {
      "font-size": "0.85rem",
      "text-align": "center",
      "white-space": "normal"
    }
  }, [_c('span', {
    staticClass: "grey--text text--darken-2"
  }, [_vm._v("(New Version with Monthly, Yearly &"), _c('br'), _vm._v("One time payment options)")])])], 1)], 1)], 1)], _vm._v(" "), [_c('v-list', {
    staticStyle: {
      "background": "rgb(255, 255, 255, 0.5)",
      "border-top": "1px solid"
    },
    attrs: {
      "one-line": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": "",
      "href": _vm.old_razorpayDonationsUrl,
      "target": "_blank"
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": "/static/doc-images/lists/hand-credit-card.png"
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('u', [_vm._v("AMBPPCT Online Donations")])]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticStyle: {
      "font-size": "0.85rem",
      "text-align": "center",
      "white-space": "normal"
    }
  }, [_c('span', {
    staticClass: "grey--text text--darken-2"
  }, [_vm._v("(Old Version with One time payment option)")])])], 1)], 1)], 1)], _vm._v(" "), _c('v-container', {
    staticStyle: {
      "padding": "0 15px",
      "min-height": "0",
      "font-size": "0.75rem"
    },
    attrs: {
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xl12": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('p', [_vm._v("\n              The Trust is supported entirely by love-gifts from Meher Baba's followers around the world. With deep appreciation, the trustees salute the love for Beloved Baba that prompts His dear ones to financially contribute so that His Trust may continue to grow and develop. With ever-increasing activities and inflation all round, more donations are very much needed to support and sustain the activities of the Trust.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              The Trust has recently updated the donation App for greater convenience. In addition to one-time donations, you can now opt for monthly or yearly donations, providing greater flexibility in supporting the Trust objectives.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              All online donations will be acknowledged by email and by a receipt from the Trust sent by mail. Income Tax exemptions are available on donations to the AMBPPC Trust in India, according to the Income Tax law.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              Tax exemption details: "), _c('br'), _vm._v("\n              Donations are eligible for benefit of deductions u/s. 80-G of the IT Act, 1961 vide Unique Registration Number : AAATA3271BF20213, dated 23-09-2021 From Assessment Year 2022-23 to 2026-27\n            ")])])], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "securityTerms",
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "xl12": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-0",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('p', [_c('a', {
    attrs: {
      "href": _vm.history,
      "target": "_blank"
    }
  }, [_vm._v("About us")]), _vm._v("  \n              "), _c('a', {
    attrs: {
      "href": _vm.contactUs,
      "target": "_blank"
    }
  }, [_vm._v("Contact us")]), _vm._v("  \n              "), _c('a', {
    attrs: {
      "href": _vm.privacyPolicy,
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": _vm.termsAndConditions,
      "target": "_blank"
    }
  }, [_vm._v("Terms & Conditions")]), _vm._v("  \n              "), _c('a', {
    attrs: {
      "href": _vm.refundNote,
      "target": "_blank"
    }
  }, [_vm._v("Refund Note")])])])], 1)], 1)], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61905d78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/donations.vue
// module id = 310
// module chunks = 1